import React from 'react';
import { MapPin } from 'lucide-react';
import { useTranslation } from '../../i18n';
import StoryAttribution from '../../components/StoryAttribution';

/**
 * Compact, presentational Movement Story card for the discovery carousels.
 * Image-forward, tap-through to the detail page — no inline reactions/comments.
 */
export default function MovementStoryCardCompact({ story, onOpen }) {
  const { t } = useTranslation('movement');

  return (
    <button
      type="button"
      className={`ms-compact${story.coverImage ? '' : ' ms-compact--noimg'}`}
      onClick={() => onOpen(story.id)}
      aria-label={story.title || t('readStory')}
    >
      {story.coverImage && <img className="ms-compact-img" src={story.coverImage} alt="" loading="lazy" />}
      <div className="ms-compact-scrim" />

      <div className="ms-compact-top">
        {story.category && <span className="ms-pill ms-pill-cat">{t(`categories.${story.category}`)}</span>}
        {story.location && (
          <span className="ms-pill ms-pill-loc"><MapPin size={11} strokeWidth={2.25} /> {story.location}</span>
        )}
      </div>

      <div className="ms-compact-bottom">
        {story.title && <h3 className="ms-compact-title">{story.title}</h3>}
        <StoryAttribution story={story} compact />
      </div>
    </button>
  );
}
